import API from '../../../utils/API'

export const getDevelopers = async (data = {}) => {
  const developers = await API.post(`${window.sapiens.api}/developers/get`, data)
  return developers
}

export const requestQuote = async (data = {}) => {
  const quote = await API.post(`${window.sapiens.api}/developers/request-quote`, data)
  return quote
}

export default {
  getDevelopers,
  requestQuote,
}
